<template>
  <ul class="menu-nav">
    <!-- <router-link
      class="menu-link menu-toggle"
      :to="{ name: 'dashboard' }"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <span class="menu-icon svg-icon svg-icon-xl">
            <inline-svg
              class="svg-icon"
              src="/media/svg/icons/Neolex/Basic/user.svg"
            />
          </span>
          <span class="menu-text">Dashboard</span>
        </a>
      </li>
    </router-link> -->
    <template v-for="(menu, index) in menus">
      <li v-if="menu.subMenu" :key="'submenu-' + index" aria-haspopup="true" data-menu-toggle="hover"
        class="menu-item menu-item-submenu">
        <template v-if="menu.showCategory">
          <a class="menu-link menu-toggle">
            <span class="menu-icon svg-icon svg-icon-xl">
              <inline-svg class="svg-icon" :src="menu.icon" />
            </span>
            <span class="menu-text">{{ menu.name }}</span>
            <i class="menu-arrow"></i>
          </a>

          <div class="menu-submenu">
            <span class="menu-arrow"></span>
            <ul class="menu-subnav">
              <template v-for="(menuItem, i) in menu.subMenu">
                <router-link v-if="menuItem.isShow" :key="'subitem-' + index + '-' + i" class="menu-link menu-toggle"
                  :to="{ name: menuItem.to }" v-slot="{ href, navigate, isActive, isExactActive }">
                  <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item" :class="[
                    isActive && 'menu-item-active',
                    isExactActive && 'menu-item-active',
                  ]">
                    <a :href="href" class="menu-link" @click="navigate">
                      <i class="menu-bullet menu-bullet-line">
                        <span></span>
                      </i>
                      <span class="menu-text">{{ menuItem.name }}</span>
                      <span v-if="menuItem.badge" class="menu-flag-badge">{{
                        menuItem.badge
                      }}</span>
                    </a>
                  </li>
                </router-link>
              </template>
              <!-- <router-link
                class="menu-link menu-toggle"
                :to="{ name: 'user_group_list' }"
                v-slot="{ href, navigate, isActive, isExactActive }"
              >
                <li
                  aria-haspopup="true"
                  data-menu-toggle="hover"
                  class="menu-item"
                  :class="[
                    isActive && 'menu-item-active',
                    isExactActive && 'menu-item-active',
                  ]"
                >
                  <a :href="href" class="menu-link" @click="navigate">
                    <i class="menu-bullet menu-bullet-line">
                      <span></span>
                    </i>
                    <span class="menu-text">Quản lý nhóm quyền</span>
                  </a>
                </li>
              </router-link> -->
            </ul>
          </div>
        </template>
      </li>
      <router-link v-else :key="'menu-' + index" class="menu-link menu-toggle" :to="{ name: menu.to }"
        v-slot="{ href, navigate, isActive, isExactActive }">
        <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item" :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]">
          <template v-if="menu.isShow">
            <a :href="href" class="menu-link" @click="navigate">
              <span class="menu-icon svg-icon svg-icon-xl">
                <inline-svg class="svg-icon" :src="menu.icon" />
              </span>
              <span class="menu-text">{{ menu.name }}</span>
            </a>
          </template>
        </li>
      </router-link>
    </template>
    <!-- <router-link
      class="menu-link menu-toggle"
      :to="{ name: 'coaches_experts' }"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <span class="menu-icon svg-icon svg-icon-xl">
            <inline-svg
              class="svg-icon"
              src="/media/svg/icons/Communication/Group.svg"
            />
          </span>
          <span class="menu-text">Huấn luyện viên & chuyên gia</span>
        </a>
      </li>
    </router-link> -->
    <!-- SETUPS: END -->
    <!-- PATIENT: BEGIN -->
    <!-- <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
    >
      <a class="menu-link menu-toggle">
        <span class="menu-icon svg-icon svg-icon-xl">
          <inline-svg
            class="svg-icon"
            src="/media/svg/icons/Neolex/Basic/pulse.svg"
          />
        </span>
        <span class="menu-text">Quản lý bệnh nhân</span>
        <i class="menu-arrow"></i>
      </a>

      <div class="menu-submenu">
        <span class="menu-arrow"></span>
        <ul class="menu-subnav">
          <router-link
            class="menu-link menu-toggle"
            :to="{ name: 'patient_list' }"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-line">
                  <span></span>
                </i>
                <span class="menu-text">Danh sách bệnh nhân</span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
      <div class="menu-submenu">
        <span class="menu-arrow"></span>
        <ul class="menu-subnav">
          <router-link
            class="menu-link menu-toggle"
            :to="{ name: 'history_kpis' }"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-line">
                  <span></span>
                </i>
                <span class="menu-text">Lịch sử nhập liệu KPIs</span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li> -->
    <!-- PATIENT: END -->
  </ul>
</template>

<script>
import intersection from 'lodash/intersection';
import { PAGE_CODE, PERMISSION_TYPE } from '@/core/plugins/constants';
export default {
  name: 'KTMenu',
  data() {
    return {
      menus: [
        {
          name: 'Quản lý tài khoản',
          icon: '/media/svg/icons/Code/Lock-overturning.svg',
          subMenu: [
            {
              name: 'Quản lý giới thiệu',
              to: 'tracking_share_app',
              pageCode: PAGE_CODE.TRACKING_SHARE_APP,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Quản lý tài khoản Portal',
              to: 'user_portal_list',
              pageCode: PAGE_CODE.ACCOUNT_ACCOUNT_PORTAL,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Quản lý tài khoản App',
              to: 'user_app_list',
              pageCode: PAGE_CODE.ACCOUNT_ACCOUNT_APP,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Quản lý vai trò',
              to: 'permission_role',
              pageCode: PAGE_CODE.ACCOUNT_ROLE,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Quản lý phòng ban',
              to: 'department',
              pageCode: PAGE_CODE.ACCOUNT_DEPARTMENT,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              // TODO: gán pageCode: PAGE_CODE.SDK_PARTNER khi backend đã seed permission
              name: 'Quản lý SDK Partner',
              to: 'sdk_partner',
            },
          ],
        },
        {
          name: 'Quản lý khách hàng',
          icon: '/media/svg/icons/General/UserCircleGear.svg',
          subMenu: [
            {
              name: 'Kích hoạt tài khoản',
              to: 'active_account_list',
              pageCode: PAGE_CODE.CUSTOMER_GROUP,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Dashboard khách hàng',
              to: 'user_dashboard_find',
              pageCode: PAGE_CODE.USER_DASHBOARD,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Dashboard nhóm huấn luyện',
              to: 'CoachCustomers',
              pageCode: PAGE_CODE.MY_CUSTOMER,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Quản lý nhóm huấn luyện',
              to: 'CoachList',
              pageCode: PAGE_CODE.USER_DASHBOARD,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Dashboard Tracking',
              to: 'dashboard_tracking_list',
              pageCode: PAGE_CODE.DASHBOARD_TRACKING,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Khách hàng PSC',
              to: 'customer_center',
              pageCode: PAGE_CODE.CUSTOMER_CENTER,
              permissions: [PERMISSION_TYPE.VIEW],
            },

            {
              name: 'Danh sách tiếp nhận',
              to: 'customer_receives_list',
              pageCode: PAGE_CODE.CUSTOMER_RECEIVES,
              permissions: [PERMISSION_TYPE.VIEW],
            },
          ],
        },
        {
          name: 'Quản lý khóa học',
          icon: '/media/svg/icons/Home/Book-open.svg',
          subMenu: [
            {
              name: 'Quản lý cấp độ',
              to: 'level',
              pageCode: PAGE_CODE.LESSON_LEVEL,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Quản lý chủ đề',
              to: 'module',
              pageCode: PAGE_CODE.LESSON_MODULE,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Quản lý bài học',
              to: 'lesson',
              pageCode: PAGE_CODE.LESSON,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Quản lý câu hỏi',
              to: 'quize',
              pageCode: PAGE_CODE.QUIZ,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Danh sách khóa học',
              to: 'courses_list',
              pageCode: PAGE_CODE.COURSES,
              permissions: [PERMISSION_TYPE.VIEW],
            },
          ],
        },
        // {
        //   name: 'Quản lý Voucher',
        //   icon: '/media/svg/icons/Code/gift.svg',
        //   subMenu: [
        //     {
        //       name: 'Dashboard Voucher',
        //       to: 'voucher',
        //       pageCode: PAGE_CODE.VOUCHERS,
        //       permissions: [PERMISSION_TYPE.VIEW],
        //     },
        //   ],
        // },
        //{
        //  name: 'Danh sách Report',
        //  icon: '/media/svg/icons/Code/Thunder-circle.svg',
        //  subMenu: [
        //    {
        //      name: 'Daily Tracking App',
        //      to: 'report4',
        //      pageCode: PAGE_CODE.REPORT,
        //      permissions: [PERMISSION_TYPE.VIEW],
        //    },
        //    {
        //      name: 'Tổng Hợp Dữ Liệu Sử Dụng App',
        //      to: 'report2',
        //      pageCode: PAGE_CODE.REPORT,
        //      permissions: [PERMISSION_TYPE.VIEW],
        //    },
        //    {
        //      name: 'Báo cáo đầu vào',
        //      to: 'report3',
        //      pageCode: PAGE_CODE.REPORT,
        //      permissions: [PERMISSION_TYPE.VIEW],
        //    },
        //    {
        //      name: 'Final Data DSMES',
        //      to: 'report1',
        //      pageCode: PAGE_CODE.REPORT,
        //      permissions: [PERMISSION_TYPE.VIEW],
        //    },
        //  ],
        //},
        {
          name: 'Quản lý khảo sát',
          icon: '/media/svg/icons/Neolex/File/clipboard-text.svg',
          subMenu: [
            {
              name: 'Quản lý khảo sát',
              to: 'survey_list',
              pageCode: PAGE_CODE.SURVEY,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Quản lý bộ câu hỏi',
              to: 'survey_quize_list',
              pageCode: PAGE_CODE.SURVEY_QUESTION_GROUP,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Kết quả khảo sát',
              to: 'survey_result_list',
              pageCode: PAGE_CODE.SURVEY_QUESTION_GROUP,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Mức độ tương tác',
              to: 'lesson_result_list',
              pageCode: PAGE_CODE.SURVEY_QUESTION_GROUP,
              permissions: [PERMISSION_TYPE.VIEW],
            },
          ],
        },
        {
          name: 'Quản lý đặt lịch',
          icon: '/media/svg/icons/Neolex/Time/calendar.svg',
          to: 'coaches_calendar',
          pageCode: PAGE_CODE.COACHES_CALENDAR,
          permissions: [PERMISSION_TYPE.VIEW],
        },
        // {
        //   name: 'Huấn luyện viên',
        //   icon: '/media/svg/icons/Communication/Group.svg',
        //   subMenu: [
        //     {
        //       name: 'Dashboard khách hàng (cũ)',
        //       to: 'coaches_experts',
        //       pageCode: PAGE_CODE.COACHES_EXPERTS,
        //       permissions: [PERMISSION_TYPE.VIEW],
        //     },
        //     {
        //       name: 'Lịch làm việc',
        //       to: 'calendar_list',
        //       pageCode: PAGE_CODE.CALENDAR,
        //       permissions: [PERMISSION_TYPE.VIEW],
        //     },
        //   ],
        // },
        {
          name: 'Cổng giao tiếp',
          icon: '/media/svg/icons/Communication/Outgoing-mail.svg',
          subMenu: [
            {
              name: 'Thông báo',
              to: 'communication_list',
              pageCode: PAGE_CODE.COMMUNICATION,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            // {
            //   name: 'Hỏi đáp chuyên gia',
            //   to: 'question_response',
            //   pageCode: PAGE_CODE.QUESTION,
            //   permissions: [PERMISSION_TYPE.VIEW],
            // },
          ],
        },

        {
          name: 'Chương trình',
          icon: '/media/svg/icons/Neolex/Basic/hourglass_bottom.svg',
          subMenu: [
            {
              name: 'Danh sách KH tham gia gói dịch vụ',
              to: 'user_package_list',
              pageCode: PAGE_CODE.USER_PACKAGE,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Dashboard - Operator',
              to: 'coach_note_dashboard',
              pageCode: PAGE_CODE.COACH_NOTE_DASHBOARD,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Danh sách gói dịch vụ',
              to: 'service_package_list',
              pageCode: PAGE_CODE.SERVICE_PACKAGE,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Danh sách chương trình',
              to: 'program_list',
              pageCode: PAGE_CODE.PROGRAM,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Danh sách module chương trình',
              to: 'program_module_list',
              pageCode: PAGE_CODE.PROGRAM_MODULE,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Danh sách hoạt động chương trình',
              to: 'program_activity_list',
              pageCode: PAGE_CODE.PROGRAM_ACTIVITY,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Cấp độ hoạt động chương trình',
              to: 'program_activity_level_list',
              pageCode: PAGE_CODE.PROGRAM_ACTIVITY_LEVEL,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Loại hoạt động chương trình',
              to: 'activity_type_list',
              pageCode: PAGE_CODE.ACTIVITY_TYPE,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Chủ đề hoạt động chương trình',
              to: 'activity_topic_list',
              pageCode: PAGE_CODE.ACTIVITY_TOPIC,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Số ngày hiển thị hoạt động',
              to: 'activity_display_day_list',
              pageCode: PAGE_CODE.ACTIVITY_DISPLAY_DAY,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            // {
            //   name: 'Quản lý nhắc nhở hoạt động',
            //   to: 'program_activity_reminder_list',
            //   pageCode: PAGE_CODE.PROGRAM_ACTIVITY_REMINDER,
            //   permissions: [PERMISSION_TYPE.VIEW],
            // },
            // /////// Remove
            // {
            //   name: 'ServicePackageProgram',
            //   to: 'service_package_program_list',
            //   pageCode: PAGE_CODE.SERVICE_PACKAGE_PROGRAM,
            //   permissions: [PERMISSION_TYPE.VIEW],
            // },
            // {
            //   name: 'ActivityParameter',
            //   to: 'activity_parameter_list',
            //   pageCode: PAGE_CODE.ACTIVITY_PARAMETER,
            //   permissions: [PERMISSION_TYPE.VIEW],
            // },
            // {
            //   name: 'ProgramModuleActivity',
            //   to: 'program_module_activity_list',
            //   pageCode: PAGE_CODE.PROGRAM_MODULE_ACTIVITY,
            //   permissions: [PERMISSION_TYPE.VIEW],
            // },
            // {
            //   name: 'ProgramProgramModule',
            //   to: 'program_program_module_list',
            //   pageCode: PAGE_CODE.PROGRAM_PROGRAM_MODULE,
            //   permissions: [PERMISSION_TYPE.VIEW],
            // },
            {
              name: 'Theo dõi gói dịch vụ KH',
              to: 'tran_user_package_list',
              pageCode: PAGE_CODE.TRAN_USER_PACKAGE,
              permissions: [PERMISSION_TYPE.VIEW],
            },

            // {
            //   name: 'TranServicePackage',
            //   to: 'tran_service_package_list',
            //   pageCode: PAGE_CODE.TRAN_SERVICE_PACKAGE,
            //   permissions: [PERMISSION_TYPE.VIEW],
            // },
            // {
            //   name: 'TranProgram',
            //   to: 'tran_program_list',
            //   pageCode: PAGE_CODE.TRAN_PROGRAM,
            //   permissions: [PERMISSION_TYPE.VIEW],
            // },

            // {
            //   name: 'TranActivityParameter',
            //   to: 'tran_activity_parameter_list',
            //   pageCode: PAGE_CODE.TRAN_ACTIVITY_PARAMETER,
            //   permissions: [PERMISSION_TYPE.VIEW],
            // },
            // {
            //   name: 'TranProgramActivityReminder',
            //   to: 'tran_program_activity_reminder_list',
            //   pageCode: PAGE_CODE.TRAN_PROGRAM_ACTIVITY_REMINDER,
            //   permissions: [PERMISSION_TYPE.VIEW],
            // },
            // {
            //   name: 'TranProgramModule',
            //   to: 'tran_program_module_list',
            //   pageCode: PAGE_CODE.TRAN_PROGRAM_MODULE,
            //   permissions: [PERMISSION_TYPE.VIEW],
            // },
            // {
            //   name: 'TranProgramModuleActivity',
            //   to: 'tran_program_module_activity_list',
            //   pageCode: PAGE_CODE.TRAN_PROGRAM_MODULE_ACTIVITY,
            //   permissions: [PERMISSION_TYPE.VIEW],
            // },
            // {
            //   name: 'TranProgramProgramModule',
            //   to: 'tran_program_program_module_list',
            //   pageCode: PAGE_CODE.TRAN_PROGRAM_PROGRAM_MODULE,
            //   permissions: [PERMISSION_TYPE.VIEW],
            // },

            // {
            //   name: 'TranProgramActivity',
            //   to: 'tran_program_activity_list',
            //   pageCode: PAGE_CODE.TRAN_PROGRAM_ACTIVITY,
            //   permissions: [PERMISSION_TYPE.VIEW],
            // },
            // {
            //   name: 'TranUserPackageActivityReminder',
            //   to: 'tran_user_package_activity_reminder_list',
            //   pageCode: PAGE_CODE.TRAN_USER_PACKAGE_ACTIVITY_REMINDER,
            //   permissions: [PERMISSION_TYPE.VIEW],
            // },
          ],
        },
        // {
        //   name: 'Zoom Video',
        //   icon: '/media/svg/icons/Neolex/Connection/broadcast.svg',
        //   to: 'zoom_login',
        //   pageCode: PAGE_CODE.ZOOMLOGIN,
        //   permissions: [PERMISSION_TYPE.VIEW],
        // },

        {
          name: 'Công cụ',
          icon: '/media/svg/icons/Code/Puzzle.svg',
          subMenu: [

            {
              name: 'Zoom Link Converter',
              to: 'zoom_converter',
              pageCode: PAGE_CODE.ZOOM_CONVERTER,
              permissions: [PERMISSION_TYPE.VIEW],
            }


          ],
        },
         {
          name: 'Gói dịch vụ',
          icon: '/media/svg/icons/Shopping/Credit-card.svg',
          subMenu: [
            {
              name: 'Dashboard Bundle',
              to: 'clinic_dashboard',
              pageCode: PAGE_CODE.CLINIC_DASHBOARD,
              permissions: [PERMISSION_TYPE.VIEW],
            },
             {
              name: 'Quản lý gói',
              to: 'package_management',
              pageCode: PAGE_CODE.PACKAGE_MANAGEMENT,
              permissions: [PERMISSION_TYPE.VIEW],
            },
             {
              name: 'Dịch vụ & Sản phẩm',
              to: 'services_products',
              pageCode: PAGE_CODE.SERVICES_PRODUCTS,
              permissions: [PERMISSION_TYPE.VIEW],
            },
             {
              name: 'Đăng ký gói',
              to: 'package_registration',
              pageCode: PAGE_CODE.PACKAGE_REGISTRATION,
              permissions: [PERMISSION_TYPE.VIEW],
            },
             {
              name: 'Ghi nhận sử dụng',
              to: 'usage_recording',
              pageCode: PAGE_CODE.USAGE_RECORDING,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Ưu đãi',
              to: 'benefit_type',
              pageCode: PAGE_CODE.BENEFIT_TYPE,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            // {
            //   name: 'Voucher',
            //   to: 'clinic_voucher',
            //   pageCode: PAGE_CODE.VOUCHERS,
            //   permissions: [PERMISSION_TYPE.VIEW],
            // },
          ],
        },
        {
          name: 'BCB Campaign',
          icon: '/media/svg/icons/Shopping/Gift.svg',
          subMenu: [
            {
              name: 'Danh sách chiến dịch',
              to: 'bcb-campaign',
              pageCode: PAGE_CODE.BCB_CAMPAIGN,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Danh sách khách hàng',
              to: 'bcb-campaign-customer-list',
              pageCode: PAGE_CODE.BCB_CAMPAIGN_CUSTOMER,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Lịch khám',
              to: 'bcb-exam-calendar',
              pageCode: PAGE_CODE.BCB_PARTNER,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Quản lý đối tác',
              to: 'bcb-partner',
              pageCode: PAGE_CODE.BCB_PARTNER,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              // Chỉ phục vụ review kết quả OCR tự động từ flow BCB — chuyển vào đây thay vì
              // đứng menu riêng vì hiện tại chưa dùng ở đâu khác ngoài BCB Campaign.
              name: 'Báo cáo sức khỏe',
              to: 'health_report',
              pageCode: PAGE_CODE.HEALTH_REPORT,
              permissions: [PERMISSION_TYPE.VIEW],
            },
          ],
        },
        {
          name: 'Cài đặt',
          icon: '/media/svg/icons/Code/Settings4.svg',
          subMenu: [
            {
              name: 'Quản lý lộ trình',
              to: 'movement_route_list',
              pageCode: PAGE_CODE.AGENDA,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Tham số hệ thống',
              to: 'system_parameter',
              pageCode: PAGE_CODE.COMMON_CONFIGURE_TASK_PARAMETER,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Model AI',
              to: 'ai_model_settings',
              pageCode: PAGE_CODE.COMMON_CONFIGURE_TASK_PARAMETER,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Chất lượng AI',
              to: 'ai_quality',
              pageCode: PAGE_CODE.COMMON_CONFIGURE_TASK_PARAMETER,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Ngưỡng đường huyết',
              to: 'glucose_list',
              pageCode: PAGE_CODE.GLUCOSE,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Danh sách vận động',
              to: 'exercise_list',
              pageCode: PAGE_CODE.EXERCISE,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Danh sách món ăn',
              to: 'food_list',
              pageCode: PAGE_CODE.FOOD_CATEGORY,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Danh sách thực đơn mẫu',
              to: 'menu_list',
              pageCode: PAGE_CODE.FOOD_MENU,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Ngưỡng BMI / cân nặng',
              to: 'weight_list',
              pageCode: PAGE_CODE.BMI,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Cảm xúc',
              to: 'feeling_list',
              pageCode: PAGE_CODE.EMOTION,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Khung giờ & thời gian hoạt động',
              to: 'time_frame_of_operation_list',
              pageCode: PAGE_CODE.TIME_FRAME,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Quản trị nội dung',
              to: 'content',
              pageCode: PAGE_CODE.COMMON_CONFIGURE_TASK_CONTENT,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Hướng dẫn sử dụng',
              to: 'user_guide',
              pageCode: PAGE_CODE.PROFILE_INSTRUCTION,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Bài viết nổi bật',
              to: 'article',
              pageCode: PAGE_CODE.LEARNING_POST,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Sự kiện',
              to: 'event',
              pageCode: PAGE_CODE.LEARNING_POST,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Danh sách template tin nhắn',
              to: 'message_templates_list',
              pageCode: PAGE_CODE.MESSAGE_TEMPLATES,
              permissions: [PERMISSION_TYPE.VIEW],
            }
          ],
        },
        {
          name: 'His Doctor',
          icon: '/media/svg/icons/Neolex/Basic/pulse.svg',
          to: 'dashboard_doctor_his',
          pageCode: PAGE_CODE.DASHBOARD_DOCTOR_HIS,
          permissions: [PERMISSION_TYPE.VIEW],
        },
        {
          name: 'Nhóm tính năng thử nghiệm',
          icon: '/media/svg/icons/Neolex/Basic/lightning.svg',
          subMenu: [
             {
              name: 'Change Log',
              to: 'dev_note',
              pageCode: PAGE_CODE.DEV_NOTE,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            // {
            //   name: 'Dashboard Doctor',
            //   to: 'dashboard_doctor_view',
            //   pageCode: PAGE_CODE.MESSAGE_TEMPLATES,
            //   permissions: [PERMISSION_TYPE.VIEW],
            // },
            // {
            //   name: 'Dashboard Report',
            //   to: 'dashboard_report_list',
            //   pageCode: PAGE_CODE.MESSAGE_TEMPLATES,
            //   permissions: [PERMISSION_TYPE.VIEW],
            // },
            // {
            //   name: 'Dashboard Template',
            //   to: 'dashboard_template_list',
            //   pageCode: PAGE_CODE.MESSAGE_TEMPLATES,
            //   permissions: [PERMISSION_TYPE.VIEW],
            // },
            {
              name: 'Lịch sử Zalo OA',
              to: 'zalo_chat_history_list',
              pageCode: PAGE_CODE.ZALO_CHAT_HISTORY,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              // Chữ "AI" nằm ở badge chứ không trong tên: tên menu đã dài, nhét thêm
              // tiền tố là xuống dòng trên sidebar hẹp.
              name: 'Reminder Notifications',
              badge: 'AI',
              to: 'reminder_tracking_list',
              pageCode: PAGE_CODE.USER_PACKAGE,
              permissions: [PERMISSION_TYPE.VIEW],
            },
            {
              name: 'Decision Coach',
              badge: 'AI',
              to: 'decision_ai_coach_list',
              pageCode: PAGE_CODE.DECISION_AI_COACH,
              permissions: [PERMISSION_TYPE.VIEW],
            }
            // {
            //   name: 'CustomerPartner',
            //   to: 'customer_partner_list',
            //   pageCode: PAGE_CODE.CUSTOMER_PARTNER,
            //   permissions: [PERMISSION_TYPE.VIEW],
            // },
          ],
        },
      ],
    };
  },
  computed: {
    permissions() {
      return this.$store.state.auth.permissions;
    },
  },
  watch: {
    permissions: {
      handler() {
        this.setMenu();
      },
      deep: true,
    },
  },
  mounted() {
    this.setMenu();
  },
  methods: {
    hasActiveChildren(match) {
      return this.$route['path'].indexOf(match) !== -1;
    },
    setMenu() {
      this.menus.forEach((menu) => {
        if (menu.subMenu && menu.subMenu.length) {
          menu.subMenu.forEach((menuItem) => {
            if (!menuItem.pageCode) return (menuItem['isShow'] = true);
            menuItem['isShow'] = this.isShowMenuItem(
              menuItem.pageCode,
              menuItem.permissions,
            );
          });
          menu.subMenu.filter((el) => el.isShow).length > 0
            ? (menu['showCategory'] = true)
            : (menu['showCategory'] = false);
        } else {
          if (!menu.pageCode) return (menu['isShow'] = true);
          menu['isShow'] = this.isShowMenuItem(menu.pageCode, menu.permissions);
        }
      });
      this.$forceUpdate();
    },
    isShowMenuItem(pageCode, pagePermisstions) {
      const permissionWithPage =
        this.permissions
          .find((el) => el.code === pageCode)
          ?.value.map((el) => el.nameType) || [];

      const commonPermission = intersection(
        pagePermisstions,
        permissionWithPage,
      );
      return commonPermission.length > 0;
    },
  },
};
</script>
<style scoped>
.no-wrap {
  white-space: nowrap;
}

/* Nhãn "AI" góc phải mục menu. Tên riêng .menu-flag-badge chứ không phải .badge hay
   .menu-label: hai cái đó Metronic đã định nghĩa ở global, dùng lại là dính style
   lạ mà không thấy khai báo ở đâu. */
.menu-flag-badge {
  margin-left: auto;
  padding-left: 6px;
  color: #3699ff;
  font-size: 9px;
  font-weight: 600;
  line-height: 14px;
  letter-spacing: 0.4px;
  flex: 0 0 auto;
}

/* Scrollable submenu */
.menu-submenu .menu-subnav {
  max-height: 400px;
  overflow-y: auto;
}

/* Custom scrollbar */
.menu-submenu .menu-subnav::-webkit-scrollbar {
  width: 5px;
}

.menu-submenu .menu-subnav::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.menu-submenu .menu-subnav::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.menu-submenu .menu-subnav::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}
</style>
